import loader from "@monaco-editor/loader";
import Editor from '@monaco-editor/react';

loader.config({ paths: { vs: "/vs" } });
export const CodeEditor = ({lang ,defaultValue, valueUpdated}: {lang: string,defaultValue:string , valueUpdated: (value: any) => void }) => {

  const handleEditorChange = (value:any) => { 
    valueUpdated(value)
  }

  return <Editor height="90vh" width="50vw" defaultValue={defaultValue} defaultLanguage={lang}  onChange={handleEditorChange} />
}